"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _image = _interopRequireDefault(require("../image"));
var mapCollection = function mapCollection(collection) {
  var _collection$primary$u, _collection$primary, _collection$primary$t, _collection$primary2, _collection$primary$s, _collection$primary$m;
  return {
    link: (_collection$primary$u = collection.primary.url) !== null && _collection$primary$u !== void 0 && _collection$primary$u.url ? collection.primary.url.url.replace("https:/", "") : "/",
    title: ((_collection$primary = collection.primary) === null || _collection$primary === void 0 ? void 0 : _collection$primary.title) && ((_collection$primary$t = collection.primary.title[0]) === null || _collection$primary$t === void 0 ? void 0 : _collection$primary$t.text) || "",
    subtitle: ((_collection$primary2 = collection.primary) === null || _collection$primary2 === void 0 ? void 0 : _collection$primary2.subtitle) && ((_collection$primary$s = collection.primary.subtitle[0]) === null || _collection$primary$s === void 0 ? void 0 : _collection$primary$s.text) || undefined,
    mainImage: ((_collection$primary$m = collection.primary.mainimage) === null || _collection$primary$m === void 0 ? void 0 : _collection$primary$m.url) && (0, _image["default"])(collection.primary.mainimage),
    thumbnails: (collection === null || collection === void 0 ? void 0 : collection.items.length) > 0 && collection.items.map(function (image) {
      return (0, _image["default"])(image.thumbnails);
    })
  };
};
var _default = mapCollection;
exports["default"] = _default;